'use client';

import { device } from '@repo/common-utils';
import { useUserEventLogger } from '@repo/tracking-service';
import { Card, MainTitle } from '@repo/ui';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import { RespondentCard } from '@/app/_components/chat-content/RespondentCard';
import s from '@/app/home/_components/ContentCard.module.scss';
import { ContentCardItem } from '@/lib/types/content';

const CardContent = ({
  item,
  className,
  isShowAdvertisementIcon,
  cardHoverClass
}: {
  item: ContentCardItem;
  className?: string;
  isShowAdvertisementIcon: boolean;
  cardHoverClass: string;
}) => {
  return (
    <Card
      outline={false}
      className={`${item.backgroundColorClass}  ${item.backgroundImageClass ? `${s[item.backgroundImageClass]} min-h-80 max-h-80` : 'compact:min-h-[auto] compact:max-h-[auto]'} flex flex-col justify-between relative bg-cover bg-center transition-all hover:scale-[0.985] cursor-pointer !rounded-bzc-large overflow-hidden min-h-80 max-h-80 !p-0 ${className ?? ''}`}
    >
      {isShowAdvertisementIcon && (
        <span
          className={
            'w-6 h-6 absolute top-0 right-0 z-[1] m-normal-medium rounded-full border-[1px] border-neutral-border-main  bg-neutral-background-dimmed-low flex items-center justify-center'
          }
        >
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/ic_arrow-up-right.svg`} className={'w-4 h-4'} alt="arrow icon" />
        </span>
      )}
      <MainTitle
        title={<span className={`${item.titleColorClass} line-clamp-4`}>{item.title}</span>}
        description={<span className={`${item.overTextColorClass} caption-small-semibold truncate`}>{item.overText}</span>}
        className={`flex flex-col-reverse gap-y-tiny-medium !p-normal-large ${s.title_area}`}
        size={'small'}
      />
      {item.complianceLogo && (
        <div className={'self-end p-normal-large'}>
          <img src={item.complianceLogo} alt="advertisment logo" />
        </div>
      )}
      {item.type === 'question' && (
        <div className={'mx-[8px] mb-[8px]'}>
          <div
            className={`rounded-bzc-medium py-tiny-large px-normal-medium transition-all bg-white shadow-[0_2px_4px_rgba(0,0,0,0.06)] opacity-0 ${cardHoverClass}`}
          >
            <RespondentCard name={item.respondentName} organization={item.respondentOrganization} />
          </div>
        </div>
      )}
    </Card>
  );
};

export const ContentCard = ({
  item,
  className,
  isShowAdvertisementIcon = true
}: {
  item: ContentCardItem;
  className?: string;
  isShowAdvertisementIcon?: boolean;
}) => {
  const [cardHoverClass, setCardHoverClass] = useState<string>('');
  const { sendClickEvent } = useUserEventLogger();

  useEffect(() => {
    if (!device.type) {
      setCardHoverClass('group-hover/card:opacity-100');
    }
  }, []);

  const isExternalLink = item.link.startsWith('http');

  const handleClick = () => {
    sendClickEvent(item.type === 'question' ? 'main_content-card' : 'banner_ads', { 'content-id': item.id, 'ads-link': item.link });
  };

  return (
    <Link href={item.link} target={isExternalLink ? '_blank' : '_self'} className={'group/card'} onClick={handleClick}>
      <CardContent item={item} className={className} isShowAdvertisementIcon={isShowAdvertisementIcon} cardHoverClass={cardHoverClass} />
    </Link>
  );
};
